import { getDcopsTicketSyncStatus } from '@/api/dcopsTicket';

/** Dcops 工单手动/定时同步时，更新按钮 loading（轮询轻量状态接口） */
export default {
  data() {
    return {
      syncLoading: false,
      _dcopsSyncPollTimer: null,
    };
  },
  mounted() {
    if (this.dcopsSyncKey) {
      this.refreshDcopsSyncLoading(true);
    }
  },
  beforeDestroy() {
    this.stopDcopsSyncPoll();
  },
  methods: {
    startDcopsSyncPoll() {
      this.stopDcopsSyncPoll();
      this._dcopsSyncPollTimer = setInterval(() => {
        this.refreshDcopsSyncLoading();
      }, 3000);
    },
    stopDcopsSyncPoll() {
      if (this._dcopsSyncPollTimer) {
        clearInterval(this._dcopsSyncPollTimer);
        this._dcopsSyncPollTimer = null;
      }
    },
    refreshDcopsSyncLoading(startPollIfSyncing) {
      if (!this.dcopsSyncKey) return;
      getDcopsTicketSyncStatus()
        .then((res) => {
          const status = (res && res.data && res.data.data && res.data.data.sync_status) || {};
          const wasSyncing = this.syncLoading;
          const syncing = !!status[this.dcopsSyncKey];
          this.syncLoading = syncing;
          if (syncing && startPollIfSyncing) {
            this.startDcopsSyncPoll();
          }
          if (!syncing) {
            this.stopDcopsSyncPoll();
            if (wasSyncing && typeof this.onDcopsSyncFinished === 'function') {
              this.onDcopsSyncFinished();
            }
          }
        })
        .catch(() => {});
    },
    onDcopsSyncStarted() {
      this.syncLoading = true;
      this.startDcopsSyncPoll();
    },
    handleDcopsSyncResponse(res, onSuccess) {
      const body = res && res.data;
      if (body && body.code === 200) {
        const inner = body.data || {};
        if (inner.syncing) {
          this.$message.info((inner.msg || body.message) || '同步任务已提交，请稍候');
        } else {
          this.$message.success((inner.msg || body.message) || '同步完成');
        }
        this.onDcopsSyncStarted();
        if (typeof onSuccess === 'function') {
          onSuccess(body);
        }
      } else {
        this.$message.error((body && body.message) || '同步失败');
      }
    },
  },
};
